import {
  Component,
  Input,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  AYS_VIRTUAL_CLINIC_P21_IMPORT_FAB_SELECTION_STRATEGY,
  AysVirtualClinicP21ImportFabSelectionStrategy,
} from '@bindoc-projects/virtual-clinic-domain-lib';
import {
  BdUiSingleSelectComponent,
  BdUiSingleSelectConfig,
} from '@bindoc-projects/ui-lib/selection/ui';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'kost-data-import-de-new-parameters-data-fab-selection-strategy',
  template: `
    <bd-ui-single-select
      [config]="config"
      [initialSelection]="initial"
      [selectOptions]="options"
      (selection)="onFabSelectionStrategySelect($event)"
    ></bd-ui-single-select>
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BdUiSingleSelectComponent],
})
export class VirtualClinicKostNewFabSelectionStrategyComponent implements OnInit {
  @Input() fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy;

  readonly fabSelectionStrategyChange =
    output<AysVirtualClinicP21ImportFabSelectionStrategy>();

  public readonly config: BdUiSingleSelectConfig<{
    fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy;
    displayName: string;
  }> = {
    id: 'parameters-data-fab-selection-strategy',
    selectLabel: 'Fachabteilungs-Zuordnung',
    option: {
      uniqueFnc: (option) => option.fabSelectionStrategy,
      searchOptionAccessor: (option) => option.displayName,
      sortFnc: () => 0,
    },
  };
  public readonly options: Observable<
    {
      fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy;
      displayName: string;
    }[]
  > = of(
    Object.entries(AYS_VIRTUAL_CLINIC_P21_IMPORT_FAB_SELECTION_STRATEGY).map(
      ([strategy, displayName]) => ({
        fabSelectionStrategy:
          strategy as AysVirtualClinicP21ImportFabSelectionStrategy,
        displayName,
      }),
    ),
  );

  public initial: {
    fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy;
    displayName: string;
  };

  ngOnInit(): void {
    if (this.fabSelectionStrategy) {
      this.initial = {
        fabSelectionStrategy: this.fabSelectionStrategy,
        displayName:
          AYS_VIRTUAL_CLINIC_P21_IMPORT_FAB_SELECTION_STRATEGY[
            this.fabSelectionStrategy
          ],
      };
    }
  }

  public onFabSelectionStrategySelect(selected: {
    fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy;
    displayName: string;
  }) {
    this.fabSelectionStrategy = selected.fabSelectionStrategy;

    this.fabSelectionStrategyChange.emit(selected.fabSelectionStrategy);
  }
}
